<template>
    <div>
        <h2>{{ store.lexicon[store.culture].PRContracts }}</h2>

        <div class="mb-3">
            {{ store.lexicon[store.culture].PRContracts1 }} <a href="https://pbsystem.planetbids.com/portal/15598/portal-home" target="_blank">https://pbsystem.planetbids.com/portal/15598/portal-home</a> {{ store.lexicon[store.culture].PRContracts2 }}
        </div>

        <div class="row">
            <div class="form-group col-sm-8">
                <label>{{ store.lexicon[store.culture].PRContracts3 }}</label>
                <input type="text" class="form-control" v-model="store.formData.Contract.RequestNumber" />
            </div>

            <div class="form-group col-sm-4">
                <label>{{ store.lexicon[store.culture].PRContracts4 }} <span class="required">*</span></label>
                <input type="text" class="form-control" v-model="store.formData.Contract.ProjectTitle" @input="validatePage('Contract', 'projectTitle')" />
                <div v-if="store.errors.Contract.ProjectTitle" class="error">{{ store.lexicon[store.culture].PRContracts5 }}</div>
            </div>
        </div>

        <label>{{ store.lexicon[store.culture].PRContracts6 }} <span class="required">*</span></label>
        <div class="row">
            <div class="col-sm-6">
                <div class="custom-control custom-checkbox mb-3">
                    <input type="checkbox" class="custom-control-input" id="customCheck11" v-model="store.formData.Contract.RequestedRecords" value="All Proposals/Bids (includes SBE or DBE forms)" @change="validatePage('Contract', 'requestedRecords')">
                    <label class="custom-control-label" for="customCheck11">{{ store.lexicon[store.culture].PRContracts7 }}</label>
                </div>
            </div>

            <div class="col-sm-6">
                <div class="custom-control custom-checkbox mb-3">
                    <input type="checkbox" class="custom-control-input" id="customCheck12" v-model="store.formData.Contract.RequestedRecords" value="Winning Proposals/Bids (includes SBE or DBE forms)" @change="validatePage('Contract', 'requestedRecords')">
                    <label class="custom-control-label" for="customCheck12">{{ store.lexicon[store.culture].PRContracts8 }}</label>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-sm-6">
                <div class="custom-control custom-checkbox mb-3">
                    <input type="checkbox" class="custom-control-input" id="customCheck13" v-model="store.formData.Contract.RequestedRecords" value="Scoring & Evaluation & Notes" @change="validatePage('Contract', 'requestedRecords')">
                    <label class="custom-control-label" for="customCheck13">{{ store.lexicon[store.culture].PRContracts9 }}</label>
                </div>
            </div>

            <div class="col-sm-6">
                <div class="custom-control custom-checkbox mb-3">
                    <input type="checkbox" class="custom-control-input" id="customCheck14" v-model="store.formData.Contract.RequestedRecords" value="Related Task Orders/Purchase Orders" @change="validatePage('Contract', 'requestedRecords')">
                    <label class="custom-control-label" for="customCheck14">{{ store.lexicon[store.culture].PRContracts10 }}</label>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-6">
                <div class="custom-control custom-checkbox mb-3">
                    <input type="checkbox" class="custom-control-input" id="customCheck15" v-model="store.formData.Contract.RequestedRecords" value="Awarded Contract" @change="validatePage('Contract', 'requestedRecords')">
                    <label class="custom-control-label" for="customCheck15">{{ store.lexicon[store.culture].PRContracts11 }}</label>
                    <div v-if="store.errors.Contract.RequestedRecords" class="error">{{ store.lexicon[store.culture].PRFormRequestType11 }}</div>
                </div>
            </div>
            <div class="col-6">
                <div class="form-group">
                    <input type="text" class="form-control" v-model="store.formData.Contract.OtherRecordType" placeholder="Other" />
                </div>
            </div>
        </div>

        <div class="d-flex justify-content-center">
            <button type="button" class="btn btn-outline-primary me-2" @click="store.currentTypePage == 0 ? goBackToPage('TYPE') : goBackToTypePage(store.currentTypePage - 1)">{{ store.lexicon[store.culture].Back }}</button>

            <button type="button" class="btn btn-primary" @click="store.currentTypePage == store.formData.Types.length - 1 ? goToPage('FINISH') : goToTypePage(store.currentTypePage + 1)">{{ store.lexicon[store.culture].Next }}</button>
        </div>
    </div>
</template>

<script setup>
    import { useStore } from './store.js';

    const emit = defineEmits(['goToPage', 'goBackToPage', 'goToTypePage', 'goBackToTypePage']);

    const store = useStore();

    function goToPage(pageName) {
        emit('goToPage', pageName);
    }

    function goBackToPage(pageName) {
        emit('goBackToPage', pageName);
    }

    function goToTypePage(index) {
        emit('goToTypePage', index);
    }

    function goBackToTypePage(index) {
        emit('goBackToTypePage', index);
    }

    function validatePage(pageName, fieldName) {
        emit('validatePage', pageName, fieldName);
    }

</script>